import moment from 'moment'

const TEST_VALUES = {
    "insurer": {
        address: "Тестовая, 12",
        companyName: "Рока & Копыта",
        contactName: "Тестова Тест",
        birthday: moment('1990-02-20'),
        passportSeries: "4444",
        passportNumber: "666666",
        email: "alexander.srokin@gmail.com",
        inn: "1233123124",
        kpp: "67867867867",
        phone: "+79104292188",
        type: "individual",
        gender: "Женский"
    },
    "beginDate": moment(),
    "endDate": moment().add(2, 'day'),
    "onTheRoad": true,
    "insuranceSum": 100000,
    "cargoPackaging": "wood#1",
    "cargoType": 1,
    "cargoLoadingType": "notDimension",
    "insuranceType": "C",
    "franchise": false,
    "distanceArea": "russia",
    "distanceCount": 200,
    "distanceFrom": "Серпухов",
    "distanceTo": "Москва",
    "transportType": [
        "car"
    ],
    "transportLongDelivery": false,
    "transportGuard": "none",
    "transportShipping": "container",
    "transportStorage": 0,
    "transportReload": "0",
    "calculationId": "e79655c2-cc01-4488-9ebb-69499c885e7d",
    "agreementWithProtectionPolicy": true
}

export default TEST_VALUES
